import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';
import React, { useContext } from 'react';
import Box from '../../../elements/Box';
import Text from '../../../elements/Text';

function FareItemSoldBy(props) {
  const { airlineCode, airlinesNames, soldByText, labelStyles, airlineStyles } = props;

  const { direction, translate, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  let airlineName = '';
  airlinesNames.forEach((item) => {
    if (item.airlineCode === airlineCode) {
      airlineName = translate(item.labelKey, item.defaultValue);
      return;
    }
  });

  return (
    <Box display="flex" className={`fare-item-soldby-info ${className}`} style={style}>
      <Text marginRight="1" {...labelStyles}>
        {translate(soldByText, 'Sold by:')}
      </Text>
      <Text {...airlineStyles}>{airlineName}</Text>
    </Box>
  );
}

FareItemSoldBy.componentName = 'FareItemSoldBy';

export default FareItemSoldBy;
